import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  getTransactionList,
  UpdateTransactions,
  deleteTransactions,
  ClientsList,
} from "../../api/api";
import { Button } from "../../components/Button/Button";
import Cookies from "js-cookie";
import { useTransationList, useTransationListPending } from "../../data/data";

import Switch from "react-switch";

import { Container, Offcanvas, Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import clsx from "clsx";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import _ from "lodash";
import { E } from "chart.js/dist/chunks/helpers.core";
import { formateDataCurr, formateDatabuyCurr } from "../../utils/types";
import { FormattedDate } from "react-intl";
import { DateFilter } from "ag-grid-community";

import "react-tabs/style/react-tabs.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { BASE_URL, API_KEY } from "../../api/api";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const TransactionsList = () => {
  const [email, setEmail] = useState(null);
  const [fname, setFname] = useState(null);
  const [lname, setLname] = useState(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const dataGridRefPendingMain = useRef<AgGridReact<IOlympicData>>(null);

  const [extNumber, setExtNumber] = useState(null);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [updateResponse, setUpdateResponse] = useState<any>(null);
  const [show, setShow] = useState(false);
  const [selectUser, setSelectUser] = useState<any>(null);
  const [getClientData, setGetClientData] = useState<any>(null);
  const token = Cookies.get("newJwt");
  const selectedClient: any = Cookies.get("client");
  const { data, isLoading, isFetching, refetch } = useTransationList(
    "Transactions",
    parseInt(selectedClient),
    token
  );

  useEffect(() => {
    ClientsList(Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setGetClientData(
          response?.find(
            (item: any) => item?.clientID === parseInt(selectedClient)
          )
        );
      });
  }, [selectedClient]);

  const {
    data: pendingData,
    isLoading: pendingLoading,
    isFetching: pendingFetch,
    refetch: pendingRefetch,
  } = useTransationListPending(
    "pendingTransactions",
    parseInt(selectedClient),
    token
  );

  const [StateIsActive, setStateIsActive] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [isUserDelete, setIsUserDelete] = useState(false);
  const [isUnlock, setIsUnlock] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [selectedTransactionDelete, setSelectedTransactionDelete] =
    useState<any>(null);
  const [selectedUserStatus, setSelectedUserStatus] = useState<any>(null);
  const [selectedUserUnlock, setSelectedUserUnlock] = useState<any>(null);
  const [showResponse, setShowResponse] = useState(false);
  const [responseStatus, setResponseStatus] = useState<any>();
  const [unlockResponse, setUnlockResponse] = useState(false);
  const [deleteResponse, setDeleteResponse] = useState(false);
  const [statusResponse, setStatusResponse] = useState(false);
  const [showAddTrans, setShowAddTrans] = useState(false);
  const [transactionCodeList, setTransactionCodeList] = useState<any>([]);
  const [participantFundBalance, setParticipantFundBalance] = useState<any>([]);
  const [recipient, setRecipient] = useState<any>([]);
  const [selectedParticipant, setSelectedParticipant] = useState<any>(null);
  const [selectedFund, setSelectedFund] = useState<any>(null);
  const [getBalance, setGetBalance] = useState<any>(null);
  const [getNotes, setGetNotes] = useState(null);
  const [GetHasFee, setGetHasFee] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showErrorResponse, setShowErrorResponse] = useState(false);
  const [showFailedResponse, setShowFailedResponse] = useState<any>("");
  const [editAmount, setEditAmount] = useState<any>("");
  const [transactionCode, setTransactionCode] = useState("");
  const [recipientCode, setRecipientCode] = useState<number>();
  const [reenterAmount, setReenterAmount] = useState<any>("");
  const [formData, setFormData] = useState<{ [key: string]: any }>({});

  const handleClose = () => {
    setShowModel(false);
  };

  useEffect(() => {
    getTransactionList(
      "AddTransactionTransactionCodeList",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        setTransactionCodeList(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getTransactionList(
      "AddTransactionParticipantFundBalance",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        setParticipantFundBalance(response);
      })
      .catch((err) => {
        console.log(err);
      });
    getTransactionList(
      "Recipient",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        setRecipient(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const participantList = _.uniqBy(participantFundBalance, "participantName");

  function handleChangeParticipant(e: any) {
    setSelectedParticipant(e.target.value);
  }

  const participantFrom = _.filter(participantFundBalance, {
    participantName: selectedParticipant,
  });

  function handleParticipantFrom(e: any) {
    setGetBalance(e.target.value);
  }
  const participantTo = _.filter(
    participantFrom,
    (fund) => fund.fundName !== getBalance
  );
  const participantBalance = _.find(participantFrom, { fundName: getBalance });

  const closeSidebar = () => {
    setShow(false);
    setResponse(null);
    setSelectUser(null);
    setUpdateResponse(null);
    //refetch();
  };

  const showSidebar = () => setShow(true);

  function handEmail(e: any) {
    setEmail(e.target.value);
  }
  function handleFirstName(e: any) {
    setFname(e.target.value);
  }
  function handleLastName(e: any) {
    setLname(e.target.value);
  }
  function handleExtNumber(e: any) {
    setExtNumber(e.target.value);
  }

  function handleUpdateTransaction(e: any) {
    e.preventDefault();
    setIsBtnLoading(true);
    const id = selectUser?.data?.transactionID;
    const payload = {
      // FeeAmount: ,
      FundId: selectUser?.data?.fundID,
      FundPrice: selectUser?.data?.fundPrice,
      participantID: selectUser?.data?.participantID,
      RecipientID: selectUser?.data?.recipientCode,
      // TransactionAmount:,
      TransactionCode: transactionCode
        ? transactionCode
        : selectUser?.data?.transactionCode,
      HasFees: GetHasFee ? GetHasFee : selectUser?.data?.hasFees,
      notes: getNotes,
      TransactionDate: formData.transactionDate
        ? formData.transactionDate
        : selectUser?.data?.transactionDate,
      TransactionAmount: editAmount
        ? editAmount
        : selectUser?.data?.transactionAmount,
      transactionUnits: formData.transactionAmount
        ? (selectUser?.data?.fundPrice / formData.transactionAmount).toFixed(6)
        : selectUser?.data?.transactionUnits,
      ...formData,
    };

    UpdateTransactions(id, payload, Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setUpdateResponse(response);
        setIsBtnLoading(false);
        pendingRefetch();
      })
      .catch((err) => {
        setUpdateResponse("Transaction Updated Successfully");
        refetch();
        console.log(err);
        setIsBtnLoading(false);
      });
  }

  function editUser(data: any) {
    setSelectUser(data);
    setShow(true);
  }

  function transactionDelete(data: any) {
    setSelectedTransactionDelete(data);
    setShowModel(true);
  }

  function handleDeleteTransaction() {
    const id = selectedTransactionDelete?.data?.transactionID;
    deleteTransactions(id, Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        if (response.status === 204) {
          setShowResponse(true);
          setResponseStatus(response.status);
          setDeleteResponse(true);
          setShowModel(false);
          pendingRefetch();
        } else {
          setDeleteResponse(false);
        }
      })
      .catch((err) => {
        setShowModel(false);
        refetch();
        console.log(err);
      });
  }

  //settimeout in useeffect ?
  useEffect(() => {
    if (showResponse === true) {
      setTimeout(() => {
        setShowResponse(false);
      }, 3000);
    }
  }, [showResponse]);
  const [columns, setColumns] = useState([
    {
      headerName: "Transaction ID",
      field: "transactionID",
      cellClass: "left",
      width: 120,
    },
    {
      headerName: "Participant Name",
      field: "participantName",
      sortable: true,
      flex: 1,
      //width: 180,
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Fund",
      field: "fund",
      sortable: true,
      width: 80,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },

    {
      headerName: "Transaction Code",
      field: "transactionCodeDesc",
      sortable: true,
      width: 140,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Transaction Date",
      field: "transactionDate",
      sortable: true,
      width: 140,
      floatingFilter: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
          const cellDate = new Date(cellValue);
          const cellDateAtMidnight = new Date(
            cellDate.getFullYear(),
            cellDate.getMonth(),
            cellDate.getDate()
          );
          if (
            filterLocalDateAtMidnight.getTime() === cellDateAtMidnight.getTime()
          ) {
            return 0;
          }
          if (cellDateAtMidnight < filterLocalDateAtMidnight) {
            return -1;
          }
          if (cellDateAtMidnight > filterLocalDateAtMidnight) {
            return 1;
          }
        },
        browserDatePicker: true, // Enable the browser's native date picker
      },
      cellRendererFramework: (params: any) => {
        const transactionDate = new Date(params?.data?.transactionDate);
        const formattedDate = transactionDate.toLocaleDateString(); // Format the date as desired
        return formattedDate;
      },
    },
    {
      headerName: " Amount",
      field: "transactionAmount",
      sortable: true,
      width: 100,
      cellRenderer: formateDatabuyCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },

    {
      headerName: " Units",
      field: "transactionUnits",
      sortable: true,
      width: 80,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },

    // {
    //   headerName: "Fund Price",
    //   field: "fundPrice",
    //   sortable: true,
    //   width: 90,
    //   cellRenderer: formateDataCurr,
    // },
    {
      headerName: "FeeAmount",
      field: "feeAmount",
      sortable: true,
      width: 80,
      cellRenderer: formateDataCurr,
    },
    {
      headerName: "Notes",
      field: "notes",
      sortable: true,
      width: 90,
    },
  ]);

  const [columnsPending, setColumnsPending] = useState([
    {
      headerName: "Transaction ID",
      field: "transactionID",
      cellClass: "left",
      width: 120,
    },
    {
      headerName: "Participant Name",
      field: "participantName",
      sortable: true,
      //width: 180,
      flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Fund",
      field: "fund",
      sortable: true,
      width: 80,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Transaction Code",
      field: "transactionCodeDesc",
      sortable: true,
      width: 140,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Transaction Date",
      field: "transactionDate",
      sortable: true,
      width: 140,
      floatingFilter: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
          const cellDate = new Date(cellValue);
          const cellDateAtMidnight = new Date(
            cellDate.getFullYear(),
            cellDate.getMonth(),
            cellDate.getDate()
          );
          if (
            filterLocalDateAtMidnight.getTime() === cellDateAtMidnight.getTime()
          ) {
            return 0;
          }
          if (cellDateAtMidnight < filterLocalDateAtMidnight) {
            return -1;
          }
          if (cellDateAtMidnight > filterLocalDateAtMidnight) {
            return 1;
          }
        },
        browserDatePicker: true, // Enable the browser's native date picker
      },
      cellRendererFramework: (params: any) => {
        const transactionDate = new Date(params?.data?.transactionDate);
        const formattedDate = transactionDate.toLocaleDateString(); // Format the date as desired
        return formattedDate;
      },
    },
    {
      headerName: " Amount",
      field: "transactionAmount",
      sortable: true,
      width: 90,
      cellRenderer: formateDatabuyCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },

    {
      headerName: " Units",
      field: "transactionUnits",
      sortable: true,
      width: 80,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },

    {
      headerName: "Fund Price",
      field: "fundPrice",
      sortable: true,
      width: 90,
      cellRenderer: formateDataCurr,
    },
    {
      headerName: "FeeAmount",
      field: "feeAmount",
      sortable: true,
      width: 80,
      cellRenderer: formateDataCurr,
    },
    {
      headerName: "Notes",
      field: "notes",
      sortable: true,
      width: 90,
    },
    {
      headerName: "Actions",
      field: "",
      cellClass: "text-start",
      width: 70,
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span
              onClick={() => editUser({ data: params.data })}
              className="cursor-pointer"
            >
              <i title="edit" className="fas fa-fw fa-edit"></i>
            </span>
            <span
              onClick={() => transactionDelete({ data: params.data })}
              className="cursor-pointer ml-4"
            >
              <i title="delete" className="fas fa-fw fa-trash"></i>
            </span>
          </>
        );
      },
    },
  ]);

  const handleChangeForm = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    let formattedValue: any = value;

    if (
      name === "TransactionDate" &&
      getClientData?.allocDateType === "datetime"
    ) {
      // Ensure that the value is in the correct format
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      formattedValue = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    } else if (
      name === "TransactionAmount" ||
      name === "reenterAmount" ||
      name === "TransactionUnits" ||
      name === "FeeAmount"
    ) {
      formattedValue = parseFloat(value);
    }

    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  function showCreateTransaction() {
    setShowAddTrans((current) => !current);
    setShowErrorResponse(false);
    setShow(false);
    setResponse(null);
    setSelectUser(null);
    setUpdateResponse(null);
    setGetBalance(null);
    setSelectedParticipant(null);
  }

  function handleTranscode(e: any) {
    setTransactionCode(e.target.value);
  }
  function handleRecipient(e: any) {
    setRecipientCode(parseInt(e.target.value));
  }
  function handleEditAmount(e: any) {
    setEditAmount(e.target.value);
  }
  function handleReenterAmount(e: any) {
    setReenterAmount(e.target.value);
  }
  function handleChangeNotes(e: any) {
    setGetNotes(e.target.value);
  }
  function handleChangeHasfees(e: any) {
    setGetHasFee(e.target.checked);
  }
  function handleAddTransaction(e: any) {
    e.preventDefault();
    if (participantBalance?.participantID && formData?.TransactionAmount) {
      const payload = {
        ParticipantId: participantBalance?.participantID,
        FundId: participantBalance?.fundID,
        FundPrice: participantBalance?.fundPrice,
        SettleDate: null,
        TransactionCode: transactionCode,
        RecipientID: recipientCode,
        HasFees: GetHasFee ? "Y" : "N",
        notes: getNotes,
        transactionUnits:
          selectedParticipant && getBalance
            ? (
                formData.TransactionAmount / participantBalance?.fundPrice
              ).toFixed(6)
            : "0",
        ...formData,
      };
      fetch(`${BASE_URL}/${API_KEY}/api/transactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("newJwt")}`,
          clientId: selectedClient,
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 200) {
            setSelectedParticipant(null);
            setFormData({});
          }
          setShowErrorResponse(true);
          setShowFailedResponse(response?.errors?.map((e: any) => e.message));
          //setSelectedParticipant(null);
          //setFormData({});
          setShowAddTrans(false);
          refetch();
          pendingRefetch();
        })
        .catch((error) => {
          setShowErrorResponse(false);
          console.error("An error occurred while downloading the file", error);
        });
    } else {
      setShowErrorMsg(true);
    }
  }
  const [validateAmount, setValidateAmount] = useState(false);
  const [validateEditAmount, setValidateEditAmount] = useState(false);
  useEffect(() => {
    const transactionAmount = parseFloat(formData.TransactionAmount);
    const reenterAmount = parseFloat(formData.reenterAmount);
    if (transactionAmount !== reenterAmount) {
      setValidateAmount(true);
    } else {
      setValidateAmount(false);
    }
  }, [formData.reenterAmount, formData.TransactionAmount]);

  useEffect(() => {
    const transactionAmount = parseFloat(editAmount);
    const reenterAmounts = parseFloat(reenterAmount);

    if (transactionAmount !== reenterAmounts) {
      setValidateEditAmount(true);
    } else {
      setValidateEditAmount(false);
    }
  }, [editAmount, reenterAmount]);

  useEffect(() => {
    !showFailedResponse ? setShowAddTrans(false) : setShowAddTrans(true);
  }, [showFailedResponse]);

  function handleTransactionReload() {
    refetch();
  }

  function handlePendingTransactionReload() {
    pendingRefetch();
  }
  // export pdf and excel functionality

  const handleTransactionExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (params.column.colId.includes("ID")) {
          // Format date as desired
          return params.value !== null ? `${params.value}` : "--";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleTransactionPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Transactions";
    const headers = [
      [
        "Transaction ID",
        "Participant Name",
        "Fund",
        "Transaction Code",
        "Transaction Date",
        "Amount",
        "Units",
        "Fund Price",
        "FeeAmount",
        "Notes",
      ],
    ];

    const transactionData = data.map((e: any) => [
      e.transactionID,
      e.participantName !== null ? `${e.participantName}` : "--",
      e.fund !== null ? `${e.fund}` : "--",
      e.transactionCodeDesc !== null ? `${e.transactionCodeDesc}` : "--",
      e.transactionDate !== null ? `${e.transactionDate}` : "--",
      e.transactionAmount !== null ? `$${e.transactionAmount}` : "--",
      e.transactionUnits !== null ? `${e.transactionUnits}` : "--",
      e.fundPrice !== null ? `$${e.fundPrice}` : "--",
      e.feeAmount !== null ? `$${e.feeAmount}` : "--",
      e.notes !== null ? `${e.notes}` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Transactions.pdf");
  };

  const handlePendingExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (params.column.colId.includes("ID")) {
          // Format date as desired
          return params.value !== null ? `${params.value}` : "--";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefPendingMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handlePendingPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Pending Transactions";
    const headers = [
      [
        "Transaction ID",
        "Participant Name",
        "Fund",
        "Transaction Code",
        "Transaction Date",
        "Amount",
        "Units",
        "Fund Price",
        "FeeAmount",
        "Notes",
      ],
    ];

    const transactionData = pendingData.map((e: any) => [
      e.transactionID,
      e.participantName !== null ? `${e.participantName}` : "--",
      e.fund !== null ? `${e.fund}` : "--",
      e.transactionCodeDesc !== null ? `${e.transactionCodeDesc}` : "--",
      e.transactionDate !== null ? `${e.transactionDate}` : "--",
      e.transactionAmount !== null ? `$${e.transactionAmount}` : "--",
      e.transactionUnits !== null ? `${e.transactionUnits}` : "--",
      e.fundPrice !== null ? `$${e.fundPrice}` : "--",
      e.feeAmount !== null ? `$${e.feeAmount}` : "--",
      e.notes !== null ? `${e.notes}` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("PendingTransactions.pdf");
  };

  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Transactions</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        <div className="tradeForm position-relative">
          <div className="">
            {showErrorMsg && !showErrorResponse ? (
              <div className="alert alert-danger px-2 py-3" role="alert">
                {" "}
                Please Enter The Details Below
              </div>
            ) : null}
            {showErrorResponse ? (
              <div
                className={clsx("alert px-2 py-3", {
                  "alert-success": !showFailedResponse,
                  "alert-danger": showFailedResponse,
                })}
                role="alert"
              >
                {showFailedResponse ? (
                  <span>{showFailedResponse}</span>
                ) : (
                  "Transaction created successfully"
                )}
              </div>
            ) : null}

            <Button
              type="submit"
              className="btn-primary float-end mx-2"
              size="btn-xs"
              children="Add"
              //showLoading={isBtnLoading}
              onClick={showCreateTransaction}
            />
            {showAddTrans ? (
              <div className="py-4 px-2 col-sm-12 float-end">
                <form onSubmit={handleAddTransaction}>
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputParticipant">Participant</label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder">
                      <select
                        name="validation-required"
                        className="form-select"
                        onChange={handleChangeParticipant}
                        defaultValue={
                          showFailedResponse ? selectedParticipant : ""
                        }
                      >
                        <option value="">Select</option>
                        {participantList?.map((e: any) => {
                          return (
                            <option value={e.participantName}>
                              {e.participantName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputAmount">Amount</label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder">
                      <input
                        name="TransactionAmount"
                        type="text"
                        className="form-control secure-input-field"
                        placeholder="Amount"
                        onChange={handleChangeForm}
                        defaultValue={
                          showFailedResponse ? formData?.TransactionAmount : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputFund">Fund</label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder">
                      <select
                        name="validation-required"
                        id="inputFund"
                        className="form-select"
                        onChange={handleParticipantFrom}
                        defaultValue={showFailedResponse ? getBalance : ""}
                      >
                        <option value="">Select</option>
                        {participantFrom &&
                          participantFrom.map((e: any) => {
                            return (
                              <option value={e.fundName} key={e.fundID}>
                                {e.fundName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputReenterAmount">
                        Re-enter Amount
                      </label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder">
                      <input
                        name="reenterAmount"
                        type="text"
                        className="form-control"
                        placeholder="Re-enter Amount"
                        onChange={handleChangeForm}
                        defaultValue={
                          showFailedResponse !== undefined
                            ? formData?.reenterAmount
                            : ""
                        }
                      />
                      {validateAmount &&
                      formData?.TransactionAmount !== undefined ? (
                        <small className="text-danger">
                          Amount and Re-enter Amount should be same
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputTranscode">Transcode</label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder">
                      <select
                        name="TransactionCode"
                        id="inputTranscode"
                        className="form-select"
                        onChange={handleTranscode}
                        defaultValue={showFailedResponse ? transactionCode : ""}
                      >
                        <option value="">Select</option>
                        {transactionCodeList?.map((e: any) => {
                          return (
                            <option
                              value={e.transactionCode}
                              key={e.transactionCodeID}
                            >
                              {e.transactionCodeDesc}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputUnits">Units</label>
                    </div>

                    <div className="mb-3 col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        name="TransactionUnits"
                        onChange={handleChangeForm}
                        value={
                          selectedParticipant && getBalance
                            ? (
                                formData.TransactionAmount /
                                participantBalance?.fundPrice
                              ).toFixed(6)
                            : "0"
                        }
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3 col-md-2 d-flex align-items-center">
                      <input type="hidden" value="0" />
                      <label>Fund Price</label>
                    </div>
                    <div className="mb-3 col-md-4 d-flex align-items-center">
                      <strong>
                        {selectedParticipant && getBalance
                          ? `$${participantBalance?.fundPrice}`
                          : "$0"}
                      </strong>
                    </div>
                    <div className="mb-3 col-md-2 d-flex align-items-center">
                      <label>Balance</label>
                    </div>
                    <div className="mb-3 col-md-4 d-flex align-items-center">
                      <strong>
                        {selectedParticipant && getBalance
                          ? participantBalance?.balance?.toLocaleString(
                              "en-US",
                              {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 6,
                              }
                            )
                          : "$0"}
                      </strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-2">
                      <div className="mb-3 mb-xl-0">
                        <label htmlFor="transactionDate" className="form-label">
                          Transaction Date
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="mb-3 mb-xl-0">
                        <input
                          type={
                            getClientData?.allocDateType.toLowerCase() ===
                            "smalldatetime"
                              ? "date"
                              : getClientData?.allocDateType.toLowerCase() ===
                                "datetime"
                              ? "datetime-local"
                              : "date"
                          }
                          className="form-control"
                          name="TransactionDate"
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputNotes">Notes</label>
                    </div>
                    <div className="mb-3 col-md-4">
                      <textarea
                        className="form-control"
                        name="Notes"
                        onChange={handleChangeNotes}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputFeeAmount">Has Fee</label>
                    </div>
                    <div className="mb-3 col-md-4">
                      <label className="form-check m-0">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          onChange={handleChangeHasfees}
                        />
                        <span className="form-check-label"></span>
                      </label>
                    </div>
                    <div className="mb-3 col-md-2">
                      <label htmlFor="inputFeeAmount">Fee Amount</label>
                    </div>
                    <div className="mb-3 col-md-4">
                      <input
                        name="FeeAmount"
                        type="text"
                        className="form-control"
                        placeholder="Fee Amount"
                        onChange={handleChangeForm}
                        disabled={GetHasFee ? false : true}
                      />
                    </div>
                  </div>
                  <div className="row">
                    {transactionCode ? (
                      <>
                        <div className="mb-3 col-md-2">
                          <label htmlFor="inputTranscode">
                            Recipient/Beneficiary
                          </label>
                        </div>
                        <div className="mb-3 col-md-4 error-placeholder">
                          <select
                            name="Recipient"
                            className="form-select"
                            onChange={handleRecipient}
                            defaultValue={
                              showFailedResponse ? recipientCode : ""
                            }
                          >
                            <option value="">Select</option>
                            {recipient?.map((e: any) => {
                              return (
                                <option
                                  value={e.recipientID}
                                  key={e.recipientID}
                                >
                                  {e.recipientName}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary me-2"
                    onClick={() => setShowAddTrans(false)}
                  >
                    Cancel
                  </button>
                  <Button
                    type="submit"
                    className="btn-primary mx-2"
                    size="btn-xs"
                    children="Submit"
                    showLoading={isBtnLoading}
                    disabled={validateAmount}
                    //onClick={handelUpdateUser}
                  />
                </form>
              </div>
            ) : null}

            <div className="row w-100 card py-4 px-0 ">
              <Tabs>
                <TabList>
                  <Tab>Transactions</Tab>
                  <Tab>Pending Transactions</Tab>
                </TabList>

                <TabPanel>
                  <div
                    className="col-sm-2 my-3 text-end position-absolute"
                    style={{ top: "15px", right: "0" }}
                  >
                    <i
                      className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                      style={{ fontSize: "16px" }}
                      onClick={handleTransactionExcel}
                    ></i>
                    <i
                      className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                      onClick={() => handleTransactionPdf()}
                      style={{ fontSize: "16px" }}
                    ></i>
                    <i
                      className="align-middle me-2 fa fa-refresh cursor-pointer"
                      onClick={() => handleTransactionReload()}
                      style={{ fontSize: "16px" }}
                    ></i>
                  </div>
                  {isFetching ? (
                    <div className="w-100 grid_loader">
                      <div
                        className="spinner-border text-dark me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        className="ag-theme-alpine position-relative"
                        style={{
                          height: "500px",
                          width: "100%",
                        }}
                      >
                        <AgGridReact
                          ref={dataGridRefMain}
                          rowData={data}
                          columnDefs={columns}
                          animateRows={true}
                          domLayout={"normal"}
                          pagination={true}
                          paginationPageSize={20}
                          //paginationAutoPageSize={true}
                        ></AgGridReact>
                      </div>
                    </>
                  )}
                </TabPanel>
                <TabPanel>
                  <div
                    className="col-sm-2 my-3 text-end position-absolute"
                    style={{ top: "15px", right: "0" }}
                  >
                    <i
                      className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                      style={{ fontSize: "16px" }}
                      onClick={handlePendingExcel}
                    ></i>
                    <i
                      className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                      onClick={() => handlePendingPdf()}
                      style={{ fontSize: "16px" }}
                    ></i>
                    <i
                      className="align-middle me-2 fa fa-refresh cursor-pointer"
                      onClick={() => handlePendingTransactionReload()}
                      style={{ fontSize: "16px" }}
                    ></i>
                  </div>
                  {pendingFetch ? (
                    <div className="w-100 grid_loader">
                      <div
                        className="spinner-border text-dark me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="ag-theme-alpine position-relative"
                      style={{
                        height: "500px",
                        width: "100%",
                      }}
                    >
                      <AgGridReact
                        ref={dataGridRefPendingMain}
                        rowData={pendingData}
                        columnDefs={columnsPending}
                        animateRows={true}
                        domLayout={"normal"}
                        pagination={true}
                        paginationPageSize={20}
                        //paginationAutoPageSize={true}
                      ></AgGridReact>
                    </div>
                  )}
                </TabPanel>
              </Tabs>
            </div>

            <Offcanvas
              backdrop="false"
              placement="end"
              show={show}
              onHide={closeSidebar}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Update Transaction</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {updateResponse !== null ? (
                  <div className="text-success">{updateResponse}</div>
                ) : (
                  <div className="text-danger">
                    {updateResponse?.errors?.[0]?.message}
                  </div>
                )}
                <div className="my-3 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Participant Name:
                  </label>
                  <div className="col-sm-8">
                    <strong className="d-block mt-1">
                      {selectUser?.data?.participantName}
                    </strong>
                  </div>
                </div>
                <div className="my-3 d-flex">
                  <label className="col-sm-4 col-form-label">Fund Name:</label>
                  <div className="col-sm-8">
                    <strong className="d-block my-1">
                      {selectUser?.data?.fundName}
                    </strong>
                  </div>
                </div>

                <form onSubmit={handleUpdateTransaction}>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Transaction Code
                    </label>
                    <div className="col-sm-8">
                      <select
                        name="TransactionCode"
                        id="inputTranscode"
                        className="form-control form-select"
                        onChange={handleTranscode}
                        defaultValue={selectUser?.data?.transactionCode}
                      >
                        <option value="">Select</option>
                        {transactionCodeList?.map((e: any) => {
                          return (
                            <option
                              value={e.transactionCode}
                              key={e.transactionCodeID}
                            >
                              {e.transactionCodeDesc}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">Amount</label>
                    <div className="col-sm-8">
                      <input
                        name="TransactionAmount"
                        type="text"
                        className="form-control"
                        placeholder="Amount"
                        defaultValue={selectUser?.data?.transactionAmount}
                        onChange={handleEditAmount}
                      />
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Re-enter Amount
                    </label>
                    <div className="col-sm-8">
                      <input
                        name="reenterAmount"
                        type="text"
                        className="form-control"
                        placeholder="Amount"
                        onChange={handleReenterAmount}
                        defaultValue={selectUser?.data?.transactionAmount}
                      />
                      {editAmount && validateEditAmount ? (
                        <small className="text-danger">
                          Amount and Re-enter Amount should be same
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">Units</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="TransactionUnits"
                        onChange={handleChangeForm}
                        value={
                          editAmount
                            ? editAmount / selectUser?.data.fundPrice || "0"
                            : selectUser?.data.fundPrice
                        }
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Fund Price
                    </label>
                    <div className="col-sm-8">
                      <strong className="d-block my-1">
                        {" "}
                        {"$" + selectUser?.data?.fundPrice}
                      </strong>
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">Balance:</label>
                    <div className="col-sm-8">
                      <strong className="d-block my-1">
                        {" "}
                        {selectedParticipant && getBalance
                          ? participantBalance?.balance?.toLocaleString(
                              "en-US",
                              {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 6,
                              }
                            )
                          : "$0"}
                      </strong>
                    </div>
                  </div>

                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">
                      Transaction Date:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="date"
                        className="form-control"
                        name="TransactionDate"
                        onChange={handleChangeForm}
                        defaultValue={selectUser?.data?.TransactionDate}
                      />
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">Notes:</label>
                    <div className="col-sm-8">
                      <textarea
                        className="form-control"
                        name="Notes"
                        onChange={handleChangeNotes}
                      ></textarea>
                    </div>
                  </div>
                  <div className="my-3 d-flex">
                    <label className="col-sm-4 col-form-label">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        onChange={handleChangeHasfees}
                        checked={
                          selectUser?.data?.hasFees === "Y" ? true : false
                        }
                      />
                      <span className="form-check-label mx-2">Has Fee</span>
                    </label>
                    <div className="col-sm-8">
                      <label htmlFor="inputFeeAmount">Fee Amount</label>
                      <input
                        name="FeeAmount"
                        type="text"
                        className="form-control"
                        placeholder="Fee Amount"
                        onChange={handleChangeForm}
                        defaultValue={selectUser?.data?.feeAmount}
                        disabled={
                          selectUser?.data?.hasFees === "Y" ? false : true
                        }
                      />
                    </div>
                  </div>

                  <div className="text-end mt-6">
                    <Button
                      type="button"
                      className="btn-outline-primary"
                      size="btn-xs"
                      children={"Cancel"}
                      //showLoading={isBtnLoading}
                      onClick={closeSidebar}
                    />
                    <Button
                      type="submit"
                      className="btn-primary mx-2"
                      size="btn-xs"
                      children="Submit"
                      showLoading={isBtnLoading}
                      disabled={validateEditAmount}
                      //onClick={handelUpdateUser}
                    />
                  </div>
                </form>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
      <Modal
        show={showModel}
        onHide={handleClose}
        centered
        className="modelComponent"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-6">Are you Sure, You want to Delete</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            className="btn-primary-close"
            size="btn-xs"
            children="No"
            onClick={handleClose}
          />
          <Button
            type="submit"
            className="btn-primary"
            size="btn-xs"
            children="Yes"
            onClick={handleDeleteTransaction}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export { TransactionsList };
